import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EditAvatarDialogComponent } from './edit-avatar-dialog/edit-avatar-dialog.component';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-edit-avatar',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatButtonModule,
    MatCheckboxModule
  ],
  templateUrl: './edit-avatar.component.html',
  styleUrl: './edit-avatar.component.scss'
})
export class EditAvatarComponent {
  usuario = {
    nombre: 'Nombre Usuario',
    empresa: 'Nombre Empresa',
    avatar: 'assets/avatar.png'
  };

  constructor(private dialog: MatDialog) {}

  openEditAvatarDialog() {
    const dialogRef = this.dialog.open(EditAvatarDialogComponent, {
      width: '80%',
      panelClass: 'edit-dialog'
    });

    dialogRef.afterClosed().subscribe((selectedAvatar: string) => {
      if (selectedAvatar) {
        this.usuario.avatar = selectedAvatar;
      }
    });
  }
}
